// Bevi Protein Tea theme interactions: quantity steppers, AJAX add-to-cart,
// flavor tabs, FAQ search/filter, mobile buy bar visibility.
(function () {
  function beviFormatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function beviTrack(eventName, params) {
    if (typeof window.fbq === 'function') window.fbq('track', eventName, params || {});
  }

  function openCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (window.Shopify && window.Shopify.actions && window.Shopify.actions.openCart) {
      window.Shopify.actions.openCart();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function updateCartBubble(itemCount) {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (bubble) bubble.textContent = itemCount;
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && itemCount > 0 && !document.querySelector('#cart-icon-bubble .cart-count-bubble')) {
      window.location.reload();
    }
  }

  function beviAddToCart(items, button) {
    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = 'Adicionando...';
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add request failed');
        return res.json();
      })
      .then(function (data) {
        return fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartBubble(cart.item_count);
            openCart();
            beviTrack('AddToCart', {
              content_ids: items.map(function (item) { return item.id; }),
              contents: items.map(function (item) { return { id: item.id, quantity: item.quantity }; }),
              content_type: 'product',
              value: cart.total_price / 100,
              currency: cart.currency || 'BRL',
            });
            if (button) {
              button.textContent = 'Adicionado!';
              setTimeout(function () {
                button.textContent = button.dataset.originalText;
                button.disabled = false;
              }, 1500);
            }
            return data;
          });
      })
      .catch(function (err) {
        if (button) {
          button.textContent = 'Erro — tente de novo';
          button.disabled = false;
        }
        console.error('Bevi add to cart failed', err);
      });
  }
  window.beviAddToCart = beviAddToCart;

  function renderFaq(root) {
    var category = root.dataset.faqCategory || 'all';
    var search = root.querySelector('[data-faq-search]');
    var term = search ? search.value.trim().toLowerCase() : '';
    var anyVisible = false;
    root.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var matchesCategory = category === 'all' || item.dataset.faqItem === category;
      var matchesSearch = !term || item.textContent.toLowerCase().indexOf(term) !== -1;
      item.hidden = !(matchesCategory && matchesSearch);
      if (!item.hidden) anyVisible = true;
    });
    var empty = root.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = anyVisible;
  }

  function syncQtyStepper(wrapper) {
    var input = wrapper && wrapper.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : null;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < min) value = min;
    if (max && value > max) value = max;
    input.value = value;
    wrapper.querySelectorAll('[data-qty-step]').forEach(function (button) {
      var step = parseInt(button.dataset.qtyStep, 10);
      button.disabled = (step < 0 && value <= min) || (step > 0 && max && value >= max);
    });
  }

  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn) {
      var wrapper = stepBtn.closest('[data-qty-stepper]');
      var input = wrapper.querySelector('input[type="number"]');
      var step = parseInt(stepBtn.dataset.qtyStep, 10);
      var min = parseInt(input.min || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = next;
      syncQtyStepper(wrapper);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var addBtn = e.target.closest('[data-bevi-add-to-cart]');
    if (addBtn) {
      var variantId = addBtn.dataset.variantId;
      var wrap = addBtn.closest('[data-qty-stepper]') || addBtn.closest('[data-product-card]');
      var qtyInput = wrap ? wrap.querySelector('input[type="number"]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var packMultiplier = parseInt(addBtn.dataset.packMultiplier, 10) || 1;
      var properties = {};
      if (addBtn.dataset.packId) properties._pack = addBtn.dataset.packId;
      if (addBtn.dataset.packSize) properties._pack_size = addBtn.dataset.packSize + ' latas';
      if (addBtn.dataset.packLabel) properties._pack_label = addBtn.dataset.packLabel;
      var item = { id: variantId, quantity: qty * packMultiplier };
      if (Object.keys(properties).length) item.properties = properties;
      beviAddToCart([item], addBtn);
    }

    var sizeBtn = e.target.closest('[data-pack-size]');
    if (sizeBtn) {
      var sizeToggle = sizeBtn.closest('[data-pack-size-toggle]');
      var multiplier = parseInt(sizeBtn.dataset.packSize, 10);
      sizeToggle.querySelectorAll('[data-pack-size]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      sizeBtn.classList.add('is-active');
      document.querySelectorAll('[data-product-card]').forEach(function (card) {
        var baseTotal = parseInt(card.dataset.baseTotalCents, 10);
        var baseSavings = parseInt(card.dataset.baseSavingsCents, 10);
        if (isNaN(baseTotal)) return;
        var total = baseTotal * multiplier;
        var savings = baseSavings * multiplier;
        var totalEl = card.querySelector('[data-pack-total]');
        var savingsEl = card.querySelector('[data-pack-savings]');
        var ctaPriceEl = card.querySelector('[data-pack-cta-price]');
        var unitCountEl = card.querySelector('[data-pack-unit-count]');
        if (totalEl) totalEl.textContent = beviFormatMoney(total);
        if (savingsEl) savingsEl.textContent = beviFormatMoney(savings);
        if (ctaPriceEl) ctaPriceEl.textContent = beviFormatMoney(total);
        if (unitCountEl) unitCountEl.textContent = 6 * multiplier;
        var cardAddBtn = card.querySelector('[data-bevi-add-to-cart]');
        if (cardAddBtn) {
          cardAddBtn.dataset.packMultiplier = multiplier;
          cardAddBtn.dataset.packSize = 6 * multiplier;
        }
      });
    }

    var navToggle = e.target.closest('[data-mobile-nav-toggle]');
    if (navToggle) {
      var navPanel = document.getElementById(navToggle.getAttribute('aria-controls'));
      var willOpen = navPanel.hasAttribute('hidden');
      if (willOpen) {
        navPanel.removeAttribute('hidden');
      } else {
        navPanel.setAttribute('hidden', '');
      }
      navToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('[data-mobile-nav]') && !e.target.closest('[data-mobile-nav-toggle]')) {
      document.querySelectorAll('[data-mobile-nav]:not([hidden])').forEach(function (panel) {
        panel.setAttribute('hidden', '');
        var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    var bundleBtn = e.target.closest('[data-bevi-add-bundle]');
    if (bundleBtn) {
      var ids = bundleBtn.dataset.variantIds.split(',');
      var items = ids.map(function (id) {
        return {
          id: id.trim(),
          quantity: 1,
          properties: {
            _pack: bundleBtn.dataset.packId || 'kit-de-prova',
            _pack_label: bundleBtn.dataset.packLabel || 'Kit de Prova',
          },
        };
      });
      beviAddToCart(items, bundleBtn);
    }

    var tabBtn = e.target.closest('[data-tab-trigger]');
    if (tabBtn) {
      var group = tabBtn.closest('[data-tabs]');
      group.querySelectorAll('[data-tab-trigger]').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('tabindex', '-1');
      });
      group.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.hidden = true;
      });
      tabBtn.classList.add('is-active');
      tabBtn.setAttribute('aria-selected', 'true');
      tabBtn.setAttribute('tabindex', '0');
      var panel = group.querySelector('[data-tab-panel="' + tabBtn.dataset.tabTrigger + '"]');
      if (panel) panel.hidden = false;
      if (tabBtn.dataset.tabImage) {
        var img = group.querySelector('#bevi-pd-active-image');
        if (img) img.src = tabBtn.dataset.tabImage;
      }
    }

    var faqFilter = e.target.closest('[data-faq-filter]');
    if (faqFilter) {
      var faqRoot = faqFilter.closest('[data-faq]');
      faqRoot.querySelectorAll('[data-faq-filter]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      faqFilter.classList.add('is-active');
      var cat = faqFilter.dataset.faqFilter;
      faqRoot.dataset.faqCategory = cat;
      renderFaq(faqRoot);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty-stepper] input[type="number"]')) {
      syncQtyStepper(e.target.closest('[data-qty-stepper]'));
    }
  });

  document.querySelectorAll('[data-qty-stepper]').forEach(syncQtyStepper);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mobile-nav]:not([hidden])').forEach(function (panel) {
        panel.setAttribute('hidden', '');
        var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        }
      });
      return;
    }

    var tabButtons = document.querySelectorAll('[data-tab-trigger]');
    if (tabButtons.length && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) !== -1) {
      var activeTab = e.target.closest('[data-tab-trigger]');
      if (!activeTab) return;
      var tabGroup = activeTab.closest('[data-tabs]');
      var tabs = Array.prototype.slice.call(tabGroup.querySelectorAll('[data-tab-trigger]'));
      var current = tabs.indexOf(activeTab);
      var next = current;
      if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = tabs.length - 1;
      e.preventDefault();
      tabs[next].focus();
      tabs[next].click();
    }
  });

  document.addEventListener('input', function (e) {
    var search = e.target.closest('[data-faq-search]');
    if (search) {
      var faqRoot = search.closest('[data-faq]');
      renderFaq(faqRoot);
    }
  });

  document.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('a[href*="/checkout"]');
    if (checkoutLink) beviTrack('InitiateCheckout');
  });

  // Mobile buy bar: show after scrolling past hero, hide while #packs is visible
  document.addEventListener('DOMContentLoaded', function () {
    var hero = document.querySelector('.bevi-hero');
    if (hero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var cans = hero.querySelectorAll('[class*="bevi-hero__can--shopify-"]');
      hero.addEventListener('pointermove', function (event) {
        if (event.pointerType !== 'mouse') return;
        var rect = hero.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        var y = ((event.clientY - rect.top) / rect.height) * 2 - 1;
        cans.forEach(function (can, index) {
          var depth = index === 1 ? 8 : 14;
          var rotation = index === 0 ? -6 : index === 2 ? 6 : 0;
          can.style.transform = 'translate(' + (x * depth) + 'px,' + (y * depth * .5) + 'px) rotate(' + (rotation + x * (index === 1 ? 1.5 : 2.5)) + 'deg)';
        });
      });
      hero.addEventListener('pointerleave', function () {
        cans.forEach(function (can, index) {
          can.style.transform = 'rotate(' + (index === 0 ? -6 : index === 2 ? 6 : 0) + 'deg)';
        });
      });
    }

    var bar = document.querySelector('[data-mobile-buy-bar]');
    var packs = document.getElementById('packs');
    if (!bar) return;

    var packsVisible = false;
    if (packs && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          packsVisible = entries[0].isIntersecting;
          render();
        },
        { threshold: 0.15 }
      );
      observer.observe(packs);
    }

    function render() {
      var scrolled = window.scrollY > 320;
      bar.classList.toggle('is-visible', scrolled && !packsVisible);
    }

    window.addEventListener('scroll', render, { passive: true });
    render();
  });
})();
